import React from 'react';
import { motion } from 'framer-motion';

const PlumbingSection = () => {
  const plumbingProducts = [
    {
      name: 'Angle Valve',
      code: '510052',
      size: '1/2 x 1/2',
      price: 'KSH 2,499',
      image: '/api/placeholder/300/300'
    },
    {
      name: 'Pipe Cutter',
      code: '510053',
      size: '3/4"',
      price: 'KSH 1,850',
      image: '/api/placeholder/300/300'
    },
    {
      name: 'Copper Fitting',
      code: '510054',
      size: '1"',
      price: 'KSH 1,275',
      image: '/api/placeholder/300/300'
    },
    {
      name: 'PVC Pipe',
      code: '510055',
      size: '2" x 10ft',
      price: 'KSH 3,299',
      image: '/api/placeholder/300/300'
    }
  ];

  return (
    <section id="plumbing" className="py-20 bg-white">
      <div className="container mx-auto px-6">
        <motion.div
          className="text-center mb-16"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
        >
          <h2 className="text-4xl font-bold text-gray-800 mb-4">Plumbing Equipment</h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            High-quality plumbing fixtures, pipes and tools for professional and DIY projects.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {plumbingProducts.map((product, index) => (
            <motion.div
              key={product.code}
              className="bg-white rounded-2xl shadow-lg border border-gray-200 overflow-hidden hover:shadow-2xl transition-all duration-300"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              viewport={{ once: true }}
              whileHover={{ y: -8 }}
            >
              <div className="h-48 bg-gradient-to-br from-blue-100 to-blue-200 flex items-center justify-center">
                <div className="text-center">
                  <div className="w-16 h-16 bg-blue-500 rounded-lg mx-auto mb-2 flex items-center justify-center">
                    <span className="text-white font-bold text-lg">🚰</span>
                  </div>
                  <span className="text-blue-600 text-sm font-medium">Plumbing</span>
                </div>
              </div>
              <div className="p-6">
                <h3 className="text-lg font-bold text-gray-800 mb-2">{product.name}</h3>
                <div className="space-y-1 text-sm text-gray-600 mb-4">
                  <div>Code: {product.code}</div>
                  <div>Size: {product.size}</div>
                </div>
                <div className="flex items-center justify-between">
                  <span className="text-2xl font-bold text-blue-600">{product.price}</span>
                  <motion.button
                    className="bg-blue-600 text-white px-4 py-2 rounded-lg text-sm font-medium hover:bg-blue-700 transition-colors duration-300"
                    whileHover={{ scale: 1.05 }}
                    whileTap={{ scale: 0.95 }}
                  >
                    Add to Cart
                  </motion.button>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default PlumbingSection;
